import script from "./ActionFooter.vue?vue&type=script&setup=true&lang=ts"
export * from "./ActionFooter.vue?vue&type=script&setup=true&lang=ts"

import "./ActionFooter.vue?vue&type=style&index=0&id=4ea31b74&scoped=true&lang=less"
import "./ActionFooter.vue?vue&type=style&index=1&id=4ea31b74&lang=less"

import exportComponent from "D:\\客户端h5\\operationmanual\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4ea31b74"]])

export default __exports__